module.exports = "/_next/static/images/0bb79248f2c3fc231d041ce9864f644c-LogoAmazon.jpg";